import Immutable from 'immutable';
import get from 'lodash/get';
import { FETCH_ADVANCED } from 'pages/Settings//DiscoverySnapshots/GlobalDiscoveryConfiguration/constants';
import { fixNullCronExpression } from 'pages/Settings//DiscoverySnapshots/GlobalDiscoveryConfiguration/reducer';
import { SAVE_SYSLOG } from './constants';

const DEFAULT_TIMEZONE = 'UTC';

const ConfigurationManagement = Immutable.Record({
  trigger: 'timer',
  // triggerTime: 10,
  triggerTime: null,
  // scheduleTime: '* 0 * * *',
  scheduleTime: '',
  cron: { expression: '', timezone: DEFAULT_TIMEZONE },
});

const initialState = new ConfigurationManagement();

function settingsConfigurationManagementReducer(
  state = initialState,
  action = undefined,
) {
  switch (action.type) {
    case `${FETCH_ADVANCED}_SUCCESS`: {
      const { syslog } = action.payload;
      return new ConfigurationManagement({
        trigger: get(syslog, 'trigger'),
        triggerTime: get(syslog, 'time'),
        cron: get(syslog, 'cron'),
      }).update('cron', fixNullCronExpression(''));
    }
    case `${SAVE_SYSLOG}_SUCCESS`:
      return new ConfigurationManagement(action.payload);
    default:
      return state;
  }
}

export default settingsConfigurationManagementReducer;
